import { Link } from 'react-router-dom';
import { BUSINESS, telLink } from '../lib/business';
import { buildWhatsappUrl } from '../lib/whatsapp';

const NAV_FOOTER = [
  { to: '/servicios', label: 'Servicios' },
  { to: '/promociones', label: 'Promociones' },
  { to: '/precios', label: 'Precios' },
  { to: '/instalaciones', label: 'Instalaciones' },
  { to: '/nuestros-trabajos', label: 'Nuestros trabajos' },
  { to: '/nosotros', label: 'Nosotros' },
  { to: '/contacto', label: 'Contacto' },
  { to: '/agendar', label: 'Agendar cita' },
];

const waLink = buildWhatsappUrl(BUSINESS.whatsapp, 'Hola Zenya, me gustaría agendar una cita.');

const Footer = () => (
  <footer style={{ background: 'var(--ink-900)', color: 'var(--rose-100)', padding: '48px 5vw 24px' }}>
    <div
      style={{
        maxWidth: 1240,
        margin: '0 auto',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 200px), 1fr))',
        gap: 32,
      }}
    >
      <div>
        <img
          src="/zenya-lockup-white.png"
          alt="Zenya Nails &amp; Spa"
          style={{ height: 44, width: 'auto', display: 'block', marginBottom: 16 }}
        />
        <p style={{ fontSize: 14, lineHeight: 1.7, color: 'rgba(246,230,234,.7)', margin: 0, maxWidth: '30ch' }}>
          Nails &amp; spa en Puebla. Manicure, pestañas, faciales y masaje con cita.
        </p>
      </div>
      <div>
        <div
          style={{
            fontSize: 10.5,
            letterSpacing: '.2em',
            textTransform: 'uppercase',
            color: 'var(--rose-400)',
            marginBottom: 14,
          }}
        >
          Navegación
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 9 }}>
          {NAV_FOOTER.map((n) => (
            <Link key={n.to} to={n.to} style={{ fontSize: 14, color: 'rgba(246,230,234,.82)', textDecoration: 'none' }}>
              {n.label}
            </Link>
          ))}
        </div>
      </div>
      <div>
        <div
          style={{
            fontSize: 10.5,
            letterSpacing: '.2em',
            textTransform: 'uppercase',
            color: 'var(--rose-400)',
            marginBottom: 14,
          }}
        >
          Contacto
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 9, fontSize: 14, color: 'rgba(246,230,234,.82)' }}>
          <a href={telLink} style={{ color: 'rgba(246,230,234,.82)', textDecoration: 'none' }}>
            {BUSINESS.telefono}
          </a>
          <a
            href={waLink}
            target="_blank"
            rel="noreferrer"
            style={{ color: 'rgba(246,230,234,.82)', textDecoration: 'none' }}
          >
            WhatsApp
          </a>
          <span>{BUSINESS.direccion}</span>
        </div>
      </div>
      <div>
        <div
          style={{
            fontSize: 10.5,
            letterSpacing: '.2em',
            textTransform: 'uppercase',
            color: 'var(--rose-400)',
            marginBottom: 14,
          }}
        >
          Horario
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 9, fontSize: 14, color: 'rgba(246,230,234,.82)' }}>
          {BUSINESS.horario.map((h) => (
            <span key={h.dia}>
              {h.dia} · {h.hora}
            </span>
          ))}
        </div>
        <div style={{ display: 'flex', gap: 14, marginTop: 18 }}>
          {BUSINESS.redes.map((r) => (
            <a
              key={r.nombre}
              href={r.url}
              target="_blank"
              rel="noreferrer"
              style={{ fontSize: 13, color: 'var(--rose-300)', textDecoration: 'none' }}
            >
              {r.nombre}
            </a>
          ))}
        </div>
      </div>
    </div>
    <div
      style={{
        maxWidth: 1240,
        margin: '32px auto 0',
        paddingTop: 20,
        borderTop: '1px solid rgba(246,230,234,.14)',
        display: 'flex',
        flexWrap: 'wrap',
        gap: 10,
        justifyContent: 'space-between',
        fontSize: 12,
        color: 'rgba(246,230,234,.5)',
      }}
    >
      <span>© 2026 Zenya Nails &amp; Spa</span>
      <span>Puebla, México</span>
    </div>
  </footer>
);

export default Footer;
